import { MmaoService } from '@app/shared/components/mmao/services/mmao.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
@Component({
  selector: 'vc-preview-box',
  templateUrl: './preview-box.component.html',
  styleUrls: ['./preview-box.component.scss']
})
export class PreviewBoxComponent implements OnInit {
  @Input() title: string;
  @Input() right_pos = 0;
  @Input() width = 0;
  @Input() isActive = 0;
  @Output() resetBox = new EventEmitter<boolean>();

  public isLgUp = false;

  constructor(private mmaoService: MmaoService, private helperService: HelpersService) {}

  ngOnInit() {
    this.isLgUp = this.helperService.device.isLgUp();
    this.mmaoService.hideNotifications.subscribe(
      _ => {
        if (!this.isLgUp) {
          this.resetBox.emit(true);
        }
      },
      _ => {}
    );
  }

  closePreviewBox() {
    this.resetBox.emit(true);
  }
}
